import { FC, ReactElement } from 'react';

import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';

import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';

import { FloatingBetControls } from './FloatingBetControls';

import styles from './FloatingBetControls.module.css';

export const FloatingBetControlsConnected: FC = (): ReactElement | null => {
  const isStatsOn = useHighflyerGameStateSlice.toggleStats();
  const isWide = useIsLargerThanWide();
  if (!isStatsOn || isWide) {
    return null;
  }
  return (
    <div className={styles.floating_bet_control_overlay}>
      <FloatingBetControls />
    </div>
  );
};
